import { useQuery } from "react-query";

import { searchService } from "services";

type UseTidEquipmentSearchQueryProps = {
	pattern: string;
	page: number;
	options?: any;
};

const useTidEquipmentSearchQuery = ({
	pattern,
	page,
	options,
}: UseTidEquipmentSearchQueryProps) =>
	useQuery(
		["tidEquipmentSearch", pattern, page],
		() =>
			searchService.getTidEquipments({
				pattern,
				page,
			}),
		{
			...options,
		},
	);

export default useTidEquipmentSearchQuery;
